
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class H5App extends Vue {
  mounted() {
    // 全局样式将 html/body/#app 锁死为 overflow: hidden，后台用自己的内部滚动容器。
    // H5 页面依赖原生 window 滚动，这里给 <html> 加类以恢复滚动。
    document.documentElement.classList.add('h5-page')

    // 检测是否为移动端
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    if (isMobile) {
      console.log('H5 应用已加载 - 移动端')
    }
  }

  beforeDestroy() {
    document.documentElement.classList.remove('h5-page')
  }
}
